import { isValidUUID } from '@/utils/validation';

export const validateUUIDParam = (to, from, next) => {
  // Check if route has uuid parameter
  if (to.params.uuid) {
    if (!isValidUUID(to.params.uuid)) {
      console.error('Invalid UUID provided:', to.params.uuid);
      // Redirect to error page or home
      next({ name: 'Error', params: { message: 'Invalid content ID' } });
      return;
    }
  }
  next();
};